"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_alexa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "d0f772de-7048-474e-9c40-e53e38699739",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "e51fd7e3-35a7-4610-b38a-b52d0c219d16"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 38,
    x2: 134,
    y2: 38,
    style: {
      fill: "none",
      stroke: "#e60000",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "4.050000190734863px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e3b4ee4a-0b4a-4541-bd68-9026a6b938d5",
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 18,
    width: 76,
    height: 156,
    rx: 12,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 136,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 136,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 136,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 136,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 124,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 124,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 124,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 124,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 124,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 112,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 112,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 112,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 136,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 112,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 136,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 112,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 112,
    r: 2,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }));
}

var _default = ic_alexa;
exports.default = _default;